import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormComponentProps } from 'types/components';
import {
  MonetaryInput,
  MonetaryInputProps,
} from 'up-ops-web-shared-components/lib/components/inputs/monetary-input';

type FormMonetaryInputProps = FormComponentProps & MonetaryInputProps;

const FormMonetaryInput = ({
  defaultValue,
  name,
  rules,
  ...props
}: FormMonetaryInputProps) => {
  const { control, formState } = useFormContext();
  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      name={name}
      render={({ field, fieldState }) => {
        const { onBlur, onChange, ref, value } = field;
        const { error, invalid } = fieldState;
        return (
          <MonetaryInput
            disabled={formState.isSubmitting}
            error={invalid}
            hint={error?.message}
            innerRef={ref}
            name={name}
            onBlur={onBlur}
            onChange={(strValue: string, numValue: number) => {
              onChange(numValue);
            }}
            value={value}
            {...props}
          />
        );
      }}
      rules={rules}
    />
  );
};

export default FormMonetaryInput;
